import { SimpleCard, type SimpleCardWidth } from '@/components/ui/simple-card';

export interface BasicPageLayoutProps extends React.PropsWithChildren {
  title: React.ReactNode;
  width?: SimpleCardWidth;
  description?: React.ReactNode;
  footer?: React.ReactNode;
}

export function BasicPageLayout({
  title,
  description,
  footer,
  width = 'sm',
  children,
}: BasicPageLayoutProps): React.ReactElement {
  return (
    <main className="flex flex-1 flex-col">
      <SimpleCard width={width} centered>
        <div className="flex flex-col gap-6 p-6">
          <div className="flex flex-col gap-2 text-center">
            <h1 className="text-xl font-semibold sm:text-2xl">{title}</h1>
            {description !== undefined && <p className="text-sm text-balance text-muted-foreground">{description}</p>}
          </div>
          {children}
          {footer !== undefined && (
            <div className="flex flex-col gap-2 sm:flex-row sm:justify-center *:w-full sm:*:w-auto">{footer}</div>
          )}
        </div>
      </SimpleCard>
    </main>
  );
}
